// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".move-modal .namespaces{max-height:200px;overflow-y:scroll}.move-modal .move-modal-card{box-shadow:none;border-radius:var(--border-radius)}.move-modal .actions{text-align:right}.move-modal .card-actions{display:flex;justify-content:center}", ""]);
// Exports
module.exports = exports;
